import { createFileRoute } from "@tanstack/react-router";
import NoSubscriptionCrmPage from "@/pages/NoSubscriptionCrmPage";
import fr from "@/i18n/locales/fr.json";

const URL = "https://thiia.app/crm-sans-abonnement";
const TITLE = "CRM sans abonnement pour indépendants et TPE | Thiia";
const DESC =
  "Un CRM sans abonnement pour indépendants, coachs, consultants et TPE : packs de crédits à 29, 59 ou 99 €, achat unique, prospection IA incluse, données en Europe.";

export const Route = createFileRoute("/crm-sans-abonnement")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "fr",
          url: URL,
          mainEntity: fr.noSubCrm.faq.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Thiia", item: "https://thiia.app/" },
            { "@type": "ListItem", position: 2, name: fr.noSubCrm.breadcrumb, item: URL },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "Thiia",
          url: URL,
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, iOS, Android",
          offers: [29, 59, 99].map((price) => ({
            "@type": "Offer",
            price: String(price),
            priceCurrency: "EUR",
            category: "Pack de crédits, achat unique sans abonnement",
            url: "https://thiia.app/pricing",
          })),
        }),
      },
    ],
  }),
  component: NoSubscriptionCrmPage,
});
